import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import { ReploComponent } from "../ReploComponent";

const PlayIcon = (props: RenderComponentProps) => {
  const isPlaying = props.context.state?.isPlaying;
  return (
    <ReploComponent
      context={props.context}
      component={props.component}
      extraAttributes={props.extraAttributes}
      overrideComponentType="icon"
      overrideComponentProps={React.useMemo(
        () => ({
          iconName: isPlaying ? "pause" : "play",
          _accessibilityLabel: isPlaying ? "Pause" : "Play",
        }),
        [isPlaying],
      )}
      // @ts-expect-error: TODO (Noah, 2024-01-01, REPL-9866): These are errors
      // because the togglePlay action doesn't have a value, but that's only the
      // case because our types are wrong
      defaultActions={React.useMemo(
        () => ({
          actions: {
            onClick: [{ id: "alchemy:togglePlay", type: "togglePlay" }],
          },
          placement: "after",
        }),
        [],
      )}
    />
  );
};

export default PlayIcon;
